import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CompanyLayoutQuery($companyId: ID!, $companyLayoutId: ID!) {
    Me {
      Company(id: $companyId) {
        businessPost {
          companyLayout(id: $companyLayoutId) {
            id
            tableId
            name
            layout
            status
          }
        }
      }
    }
  }
`
